function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4 0.000488281H1C0.45 0.000488281 0 0.450488 0 1.00049V13.0005C0 13.5505 0.45 14.0005 1 14.0005H4C4.55 14.0005 5 13.5505 5 13.0005V1.00049C5 0.450488 4.55 0.000488281 4 0.000488281ZM18 0.000488281H15C14.45 0.000488281 14 0.450488 14 1.00049V13.0005C14 13.5505 14.45 14.0005 15 14.0005H18C18.55 14.0005 19 13.5505 19 13.0005V1.00049C19 0.450488 18.55 0.000488281 18 0.000488281ZM11 0.000488281H8C7.45 0.000488281 7 0.450488 7 1.00049V13.0005C7 13.5505 7.45 14.0005 8 14.0005H11C11.55 14.0005 12 13.5505 12 13.0005V1.00049C12 0.450488 11.55 0.000488281 11 0.000488281Z",
  fill: "#2A67F4"
});

function SvgIcPeriodicityHabit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPeriodicityHabit);
export default ForwardRef;